import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppSessionService } from '../shared/services/app-session/app-session.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  constructor(
    private appSession: AppSessionService,
    private router: Router
  ) { }

  ngOnInit(): void {
    if (this.appSession.basePath && this.appSession.basePath !== 'welcome') {
      this.router.navigate([this.appSession.basePath]);
    }
  }
}
